import { api } from './api';

export interface ClerkAssignment {
  id: string;
  barristerId: string;
  clerkId: string;
  role: 'primary' | 'assistant';
  isActive: boolean;
  assignedAt: string;
  clerk: {
    id: string;
    firstName: string;
    lastName: string;
    email: string;
    memberType: string;
    avatarUrl?: string | null;
  };
}

export interface BarristerAssignment {
  id: string;
  barristerId: string;
  clerkId: string;
  role: 'primary' | 'assistant';
  assignedAt: string;
  barrister: {
    id: string;
    userId: string;
    availability: string;
    user: {
      id: string;
      firstName: string;
      lastName: string;
      email: string;
      avatarUrl?: string | null;
      status: string;
      memberType: string;
    };
    practiceAreas: { practiceArea: { name: string } }[];
  };
}

export interface AvailableClerk {
  id: string;
  firstName: string;
  lastName: string;
  email: string;
  memberType: string;
}

export async function fetchClerksForBarrister(barristerId: string): Promise<ClerkAssignment[]> {
  const res = await api.get<{ data: ClerkAssignment[] }>(`/barristers/${barristerId}/clerks`);
  return res.data.data;
}

export async function fetchAvailableClerks(barristerId: string): Promise<AvailableClerk[]> {
  const res = await api.get<{ data: AvailableClerk[] }>(`/barristers/${barristerId}/clerks/available`);
  return res.data.data;
}

export async function assignClerkToBarrister(
  barristerId: string,
  clerkUserId: string,
  role: 'primary' | 'assistant' = 'assistant',
): Promise<ClerkAssignment> {
  const res = await api.post<{ data: ClerkAssignment }>(`/barristers/${barristerId}/clerks`, { clerkUserId, role });
  return res.data.data;
}

export async function removeClerkFromBarrister(barristerId: string, clerkUserId: string): Promise<void> {
  await api.delete(`/barristers/${barristerId}/clerks/${clerkUserId}`);
}

export async function fetchMyBarristers(): Promise<BarristerAssignment[]> {
  const res = await api.get<{ data: BarristerAssignment[] }>('/me/barristers');
  return res.data.data;
}
